

















import { Component, Model, Watch, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { attrOptionsManager } from "./attrOptions";

const wtPcrProduct = namespace("product");

// 商品属性选择器
@Component
export default class WtProductAttrSelect extends Vue {
  @wtPcrProduct.Action queryProductAttributes;
  @Model("change") value!: any;

  @Prop({ type: Array, default: () => ["1", "2", "3", "4", "5", "6", "7", "9"]}) attrParams!: string[];
  ATTR_TYPE_MAP_LIST = {
      "1": "brandDataOptions",
      "2": "specificationDataOptions",
      "3": "patternDataOptions",
      "4": "hubDataOptions",
      "5": "loadIndexDataOptions",
      "6": "speedGradeDataOptions",
      "7": "oeProductDataOptions",
      "9": 'levelOptions'
    };

  productAttrTypesObject = {};  

  brandDataOptions = [];
  specificationDataOptions = [];
  patternDataOptions = [];
  hubDataOptions = [];
  loadIndexDataOptions = [];
  speedGradeDataOptions = [];
  oeProductDataOptions = [];
  levelOptions = [];
  async created() {
    await this.getAttributes();
  }
  async getAttributes() {
    const productAttrTypes = this.attrParams;
    const list = await this.queryProductAttributes({
      productAttrTypes,
    });
 
    if (list) {
      productAttrTypes.forEach(key => {
        const attrValueList = list.filter(v => v.productAttrType === key);
        if (attrValueList && attrValueList.length > 0) {
          const targetList = attrValueList.map((v, index) => ({
            ...v,
            key: `${v.productAttrType}-${index}`,
            value: v.productAttrValue,
            label: v.productAttrValue
          }));
          this.$set(this, this.ATTR_TYPE_MAP_LIST[key], targetList);
          this.$set(this.productAttrTypesObject, this.ATTR_TYPE_MAP_LIST[key], targetList);
        }
      });

       // 保存到全局管理器
       attrOptionsManager.setAttrOptions(this.productAttrTypesObject);
       this.$emit("init", this.productAttrTypesObject);
    }
  }


}
